import playgroundApi from "../../api/playground";
import {IdentificadorServico} from "../../utils/identificadores-servicos-api";

export default {
  props: {
    identificador: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      response: null,
      showModal: false,
      mudou: false,
      itens: [],
      logIds: [],
    };
  },
  methods: {
    consultar() {
      this.$wait.start(`fetching_${this.identificador}`);

      this.fetch(this.identificador, this.params())
        .finally(() => {
          this.$wait.end(`fetching_${this.identificador}`);
        });
    },
    carregarMais() {
      this.$wait.start(`pagination_${this.identificador}`);

      this.fetch(
        "GET_BY_CURSOR",
        { token_id: this.token },
        this.response.links.next
      )
        .finally(() => {
          this.$wait.end(`pagination_${this.identificador}`);
        });
    },
    fetch(identificador, params, url = null) {
      return playgroundApi[identificador](params, url)
        .then((response) => {
          this.response = response.data;

          if(identificador !== "GET_BY_CURSOR") {
            this.logIds = [];
            this.itens = [];
          }

          this.logIds.push(+response.headers["log-id"])

          if (this.identificador === IdentificadorServico.CAPA_PROCESSO) {
             this.itens.push(...this.formatarListaFonte(this.response['fontes']));
          } else if (this.identificador === IdentificadorServico.ATUALIZACAO_PROCESSO) {
            this.itens.push(this.formatarAtualizacaoProcesso());
          } else if (this.identificador === IdentificadorServico.STATUS_ATUALIZACAO_PROCESSO) {
            this.itens.push(this.formatarStatusAtualizacaoProcesso());
          } else if (
            [IdentificadorServico.ATUALIZACAO_PROCESSO_RESUMO_IA, IdentificadorServico.STATUS_RESUMO_INTELIGENTE].includes(this.identificador)
          ) {
            // Formata o resultado da solicitação de atualização e o status da atualização
            this.itens.push(this.formatarAtualizacaoResumoProcesso());
          } else if (this.identificador === IdentificadorServico.PROCESSO_RESUMO_IA) {
            this.itens.push(this.formatarResumoProcesso());
          } else if (this.identificador === IdentificadorServico.PROCESSO_MOVIMENTACOES) {
            this.itens.push(...this.formatarMovimentacoesProcesso());
          } else {
             this.itens.push(...this.formatarListaProcesso());
          }

          if (response.headers.has('creditos-utilizados')) {
            this.$parent.atualizarSaldoView(+response.headers['creditos-utilizados']);
          }
        })
        .catch(({ response }) => {
          let mensagem = response.data.message;

          if(response.data.errors) {
            // exibe o primeiro erro mais específico
            mensagem = Object.values(response.data.errors).flat()[0]
          }

          if(response.data.status === 500 || response.status === 500)  {
            mensagem = "Não foi possível realizar a requisição!"
          }

          if(response.status === 402) mensagem = response.data.error;

          this.$toasted.error(mensagem, {
            duration: 3000,
          });
        })
    },
    formatarAtualizacaoProcesso() {
      return {
          status: this.response['status'] || "-",
          numeroCnj: this.response['numero_cnj'] || "-",
          enviarCallback: this.response['enviar_callback'] || "-",
          criadoEm: this.response['criado_em'] !== null
            ? new Date(this.response['criado_em']).toLocaleString(
              "pt-BR",
              { timeZone: "America/Sao_Paulo" }
            )
            : "-",
          concluidoEm: this.response['concluido_em'] !== null
            ? new Date(this.response['concluido_em']).toLocaleDateString(
              "pt-BR",
              { timeZone: "America/Sao_Paulo" }
            )
            : "-",
        }
    },
    formatarStatusAtualizacaoProcesso() {
      return {
        numeroCnj: this.response['numero_cnj'] || "-",
        status: this.response['ultima_verificacao'] !== null
          ? this.response['ultima_verificacao']['status']
          : "-",
        criadoEm: this.response['ultima_verificacao'] && this.response['ultima_verificacao']['criado_em']
          ? new Date(this.response['ultima_verificacao']['criado_em']).toLocaleDateString(
            "pt-BR",
            { timeZone: "America/Sao_Paulo" }
          )
          : "-",
        dataUltimaVerificacao: this.response['data_ultima_verificacao']
          ? new Date(this.response['data_ultima_verificacao']).toLocaleString(
            "pt-BR",
            { timeZone: "America/Sao_Paulo" }
          )
          : "-",
        tempoDesdeUltimaVerificacao: this.response['tempo_desde_ultima_verificacao']  || "-",
        concluidoEm: this.response['ultima_verificacao'] && this.response['ultima_verificacao']['concluido_em']
          ? new Date(this.response['ultima_verificacao']['concluido_em']).toLocaleDateString(
            "pt-BR",
            { timeZone: "America/Sao_Paulo" }
          )
          : "-"
      }
    },
    formatarListaProcesso() {
      let rows = [];

      this.response.items.forEach((item) => {
         let fonteFormatada = this.formatarListaFonte(item['fontes']).map(fonte => ({
            ...fonte,
              numeroCnj: item['numero_cnj'] || "-",
              poloAtivo: item['titulo_polo_ativo'] || "-",
              poloPassivo: item['titulo_polo_passivo'] || "-",
          }));

          rows.push(fonteFormatada);
      })

      return rows.flat();
    },
    formatarListaFonte(fontes) {
      let rows = [];

      fontes.forEach((fonte) => {
          let envolvidos = '';

          for (let i = 0; i < fonte.envolvidos.length; ++i) {
            if (i > 0) envolvidos += ' | ';

            let parte = `${fonte.envolvidos[i].tipo}: ${fonte.envolvidos[i].nome}`;

            fonte.envolvidos[i].advogados.forEach((advogado) => {
              parte += ` | ${advogado.tipo}: ${advogado.nome}`;
            });

            envolvidos += parte;
          }

          let arquivado = "";
          if (fonte.arquivado !== null) {
            arquivado = fonte["arquivado"] ? "Sim" : "Não";
          }

          let dataDistribuicao = "";
          if (
            fonte.capa?.hasOwnProperty("data_distribuicao")
            &&
           fonte.capa["data_distribuicao"] !== null
          ) {
            dataDistribuicao = new Date(
              fonte.capa["data_distribuicao"]
            ).toLocaleDateString("pt-BR", { timeZone: "America/Sao_Paulo" });
          }

          let dataUltimaMovimentacao =
            fonte["data_ultima_movimentacao"] !== null
              ? new Date(fonte["data_ultima_movimentacao"]).toLocaleDateString(
                "pt-BR",
                { timeZone: "America/Sao_Paulo" }
              )
              : "";

          let areaTexto = fonte.capa?.area ?? "";
          let area =
            areaTexto.charAt(0).toUpperCase() +
            areaTexto.slice(1).toLowerCase();

          rows.push([
            {
              dataDistribuicao: dataDistribuicao || "-",
              fonteSigla: fonte.sigla || "-",
              fonteSistema: fonte.sistema || "-",
              grauFormatado: fonte.grau_formatado || "-",
              assunto:
                fonte.capa?.assunto_principal_normalizado?.nome ||
                fonte.capa?.assunto ||
                "-",
              classe: fonte.capa?.classe || "-",
              area: area,
              orgaoJulgador: fonte.capa?.orgao_julgador || "-",
              valorFormatado: fonte.capa?.valor_causa.valor_formatado || "-",
              arquivado: arquivado || "-",
              dataUltimaMovimentacao: dataUltimaMovimentacao,
              envolvidos: envolvidos,
            },
          ]);
        });

      return rows.flat();
    },
    formatarAtualizacaoResumoProcesso() {
      return {
        numeroCnj: this.response['numero_cnj'] || "-",
        status: this.response['status'] || "-",
        criadoEm: this.response['criado_em']
          ? new Date(this.response['criado_em']).toLocaleDateString(
            "pt-BR",
            { timeZone: "America/Sao_Paulo" }
          )
          : "-",
        concluidoEm: this.response['concluido_em']
          ? new Date(this.response['concluido_em']).toLocaleDateString(
            "pt-BR",
            { timeZone: "America/Sao_Paulo" }
          )
          : "-"
      }
    },
    formatarResumoProcesso() {
      return {
        numeroCnj: this.response['numero_cnj'] || "-",
        conteudo: this.response['conteudo'] || "-",
        atualizadoEm: this.response['atualizado_em']
          ? new Date(this.response['atualizado_em']).toLocaleDateString(
            "pt-BR",
            { timeZone: "America/Sao_Paulo" }
          )
          : "-"
      };
    },
    formatarMovimentacoesProcesso () {
      let rows = [];

      this.response.items.forEach((item) => {
        let obj = {
          tipo: item['tipo'],
          conteudo: item['conteudo'] || "-",
          fonteSigla: item['fonte']['sigla'] || "-",
          fonteNome: item['fonte']['nome'] || "-",
          grauFormatado: item['fonte']['grau_formatado'] || "-",
          data:
            item["data"] !== null
              ? new Date(item["data"]).toLocaleDateString("pt-BR", { timeZone: "America/Sao_Paulo" })
              : "-",
          tipoPublicacao: item['tipo_publicacao'] || "-",
          textoCategoria: item['texto_categoria'] || "-",
          classificacao: "-",
          descricao: "-",
          hierarquia: "-",
          tipoFonte: item['fonte']['tipo'].replace("_", " "),
        }

        if (item['classificacao_predita']) {
          obj.classificacao = item['classificacao_predita']['nome'] ?
            item['classificacao_predita']['nome'].replace(/^./, v => v.toUpperCase())
            : "-";
          obj.descricao = item['classificacao_predita']['descricao'] || "-";
          obj.hierarquia = item['classificacao_predita']['hierarquia'] || "-";
        }

        rows.push(obj);
      })

      return rows.flat()
    }
  }
}
